export default "__VITE_ASSET__5b045b22__"